import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as actionTypes from "../../../../constants/actionTypes";
import * as componentTypes from "../../../../constants/componentTypes";
import * as resources from "../../../../constants/resources";
import * as navigationActions from "../../../../actions/navigationActions";
import * as matchingActions from "../../../../actions/matchingActions";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as translationHelper from "../../../../helpers/translationHelper";

import Modal from "../../../global/generic/Modal";
import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import SpectroMeasureButton from "../../../global/spectro/SpectroMeasureButton";
import SpectroCalibrateButton from "../../../global/spectro/SpectroCalibrateButton";
import SpectroSelectButton from "../../../global/spectro/SpectroSelectButton";
import SpectroConnectButton from "../../../global/spectro/SpectroConnectButton";

import confirmImage from "../../../../resources/img/svgicons/confirm.svg";
import warningImage from "../../../../resources/img/svgicons/warning-outline2.svg";

class QualityControlModal extends Component {
    componentDidMount = () => {
        this.props.dispatchInitAction(this.props.tabId);
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleStartCorrection = () => {
        this.props.dispatchCloseModalAction();

        if (this.props.activeTabType === componentTypes.STATISTICS_TAB) {
            this.props.dispatchOpenMatchingTabAction(this.props.tabId, this.props.measurementSpectralData);
        } else {
            this.props.dispatchSetCorrectionSceneAction(
                this.props.tabId,
                this.props.measurementSpectralData,
                this.props.targetSpectralData,
                this.props.targetFormula
            );
        }
    };

    getTargetPreview = () => {
        if (this.props.targetSpectralData === null) {
            return null;
        }

        return <div className="col-6" style={{backgroundColor: this.props.targetSpectralData.rgbHex}} />;
    };

    getTargetLab = () => {
        if (this.props.targetSpectralData === null || !this.props.targetSpectralData.isLabValid()) {
            return null;
        }

        return (
            <React.Fragment>
                <span className="color-primary">L: </span>
                {formatHelper.formatDecimal(this.props.targetSpectralData.lab[0])}
                <span className="margin-left-10 color-primary">a: </span>
                {formatHelper.formatDecimal(this.props.targetSpectralData.lab[1])}
                <span className="margin-left-10 color-primary">b: </span>
                {formatHelper.formatDecimal(this.props.targetSpectralData.lab[2])}
            </React.Fragment>
        );
    };

    getMeasurementPreview = () => {
        if (this.props.measurementSpectralData === null) {
            return (
                <div className="col-6 flex flex-align-center disabled-img">
                    <SpectroSelectButton />
                    <SpectroConnectButton />
                    <SpectroCalibrateButton />
                    <SpectroMeasureButton
                        tabId={this.props.tabId}
                        className={null}
                        size={null}
                        callback={actionTypes.QC_SAVE_MEASURE_RESULT_AND_RUN_COLOR_DIFFERENCE}
                    />
                </div>
            );
        }

        return (
            <div
                className="col-6 flex flex-align-center"
                style={{backgroundColor: this.props.measurementSpectralData.rgbHex}}
            />
        );
    };

    getMeasurementLab = () => {
        if (this.props.measurementSpectralData === null || !this.props.measurementSpectralData.isLabValid()) {
            return null;
        }

        return (
            <React.Fragment>
                <span className="color-primary">L: </span>
                <span>{formatHelper.formatDecimal(this.props.measurementSpectralData.lab[0])}</span>
                <span className="margin-left-10 color-primary">a: </span>
                {formatHelper.formatDecimal(this.props.measurementSpectralData.lab[1])}
                <span className="margin-left-10 color-primary">b: </span>
                {formatHelper.formatDecimal(this.props.measurementSpectralData.lab[2])}
            </React.Fragment>
        );
    };

    getCriteriumResult = (value, limit, criterium, descriptor) => {
        return (
            <React.Fragment>
                <div className="col-6 flex flex-align-center-vertical">
                    <ReactSVG
                        className={
                            " qc-check flex padding-right-5" +
                            (Math.abs(value) > limit ? " fill-error" : " fill-success")
                        }
                        src={Math.abs(value) > limit ? warningImage : confirmImage}
                    />
                    <span className={"bold" + (Math.abs(value) > limit ? " color-error" : " color-success")}>
                        {criterium}:
                    </span>
                </div>
                <span
                    className={
                        "col-2 bold padding-right-5 text-align-right" +
                        (Math.abs(value) > limit ? " color-error" : " color-success")
                    }
                >
                    {formatHelper.formatDecimal(value)}
                </span>
                <span className={"col-4 bold color-error"}>
                    {descriptor
                        ? Math.abs(value) > limit
                            ? translationHelper.getQCDescriptorTranslation(descriptor)
                            : ""
                        : ""}
                </span>
            </React.Fragment>
        );
    };

    isQualityControlFailed = () => {
        if (this.props.differenceData === null) {
            return false;
        }

        return (
            Math.abs(this.props.differenceData[this.props.colorDifferenceType].de) > this.props.deltaE ||
            Math.abs(this.props.differenceData[this.props.colorDifferenceType].dl) > this.props.deltaL ||
            Math.abs(this.props.differenceData[this.props.colorDifferenceType].da) > this.props.deltaA ||
            Math.abs(this.props.differenceData[this.props.colorDifferenceType].db) > this.props.deltaB ||
            Math.abs(this.props.differenceData[this.props.colorDifferenceType].metamerism) > this.props.metamerism
        );
    };

    getResultPanel = () => {
        if (
            this.props.differenceData === null ||
            this.props.differenceData[this.props.colorDifferenceType] === undefined
        ) {
            return (
                <div
                    className="padding-10 col-6 flex flex-align-center"
                    style={{backgroundColor: "#f6f6f6", textAlign: "center"}}
                >
                    <Translate className="font-size-1_25em" value="qualityControl.measureDispensedFormula" />
                </div>
            );
        }

        const failFlag = this.isQualityControlFailed();

        return (
            <div
                className={
                    "margin-top-10 col-11 flex padding-top-5 padding-bottom-5 flex-align-center-vertical slim-scroll " +
                    (this.props.differenceData[this.props.colorDifferenceType].de > this.props.deltaE
                        ? " border-error "
                        : " border-success ") +
                    (failFlag ? "background-warning" : "background-success")
                }
            >
                <div className="col-7">
                    <div className="flex flex-wrap flex-align-center-vertical padding-left-10">
                        {this.getCriteriumResult(
                            this.props.differenceData[this.props.colorDifferenceType].de,
                            this.props.deltaE,
                            "Delta E"
                        )}
                    </div>
                    <div className="flex flex-wrap flex-align-center-vertical padding-left-10">
                        {this.getCriteriumResult(
                            this.props.differenceData.metamerism,
                            this.props.metamerism,
                            "Metamerism"
                        )}
                    </div>
                    <div className="flex flex-wrap flex-align-center-vertical padding-left-10">
                        {this.getCriteriumResult(
                            this.props.differenceData[this.props.colorDifferenceType].dl,
                            this.props.deltaL,
                            "Delta L",
                            this.props.differenceData[this.props.colorDifferenceType].descriptorL
                        )}
                    </div>
                    <div className="flex flex-wrap flex-align-center-vertical padding-left-10">
                        {this.getCriteriumResult(
                            this.props.differenceData[this.props.colorDifferenceType].da,
                            this.props.deltaA,
                            "Delta a",
                            this.props.differenceData[this.props.colorDifferenceType].descriptorA
                        )}
                    </div>
                    <div className="flex flex-wrap flex-align-center-vertical padding-left-10">
                        {this.getCriteriumResult(
                            this.props.differenceData[this.props.colorDifferenceType].db,
                            this.props.deltaB,
                            "Delta b",
                            this.props.differenceData[this.props.colorDifferenceType].descriptorB
                        )}
                    </div>
                </div>
                <div className="col-5 flex flext-align-center-horizontal">
                    <ReactSVG
                        className={"flex qc-checkResult padding-right-5" + (failFlag ? " fill-error" : " fill-success")}
                        src={failFlag ? warningImage : confirmImage}
                    />
                    <div className="flex flex-wrap flext-align-center-horizontal">
                        <Translate
                            className={"col-12 font-size-1_75em " + (failFlag ? "color-error" : "color-success")}
                            style={{alignSelf: "center"}}
                            value={
                                failFlag ? "qualityControl.qualityControlFailed" : "qualityControl.qualityControlPassed"
                            }
                        />
                        <br />
                        {failFlag ? (
                            <Translate
                                className="color-error"
                                value="qualityControl.pleaseContinueToFormulaCorrection"
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex flex-wrap flex-align-center-horizontal">
                    <div className="col-12 flex flex-wrap flex-align-center-horizontal">
                        <div className="col-11 flex">
                            <div className="col-6">
                                <Translate className="color-primary col-6" value="matching.originalFormula" />
                            </div>
                            <div className="col-6 align-left" style={{textAlign: "right"}}>
                                <Translate
                                    className="color-primary col-6"
                                    value="qualityControl.dispensedMeasuredFormula"
                                />
                            </div>
                        </div>
                        <div className="col-11 flex border-black" style={{height: "150px"}}>
                            {this.getTargetPreview()}
                            {this.getMeasurementPreview()}
                        </div>
                        <div className="col-11 flex">
                            <div className="col-6 padding-bottom-10">{this.getTargetLab()}</div>
                            <div className="col-6 align-left padding-bottom-10" style={{textAlign: "right"}}>
                                {this.getMeasurementLab()}
                            </div>
                        </div>
                    </div>
                    {this.getResultPanel()}
                </div>
            </React.Fragment>,
            "slim-scroll"
        );
    };

    getFooter = () => {
        if (
            this.props.loggedUser.canEdit(resources.FUNCTION_AUTOMATIC_CORRECTION) &&
            this.props.differenceData !== null
        ) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <CancelButton onClick={this.handleCloseModalClick} />
                    <Button
                        label={<Translate value="matching.startCorrection" />}
                        onClick={this.handleStartCorrection}
                    />
                </React.Fragment>
            );
        }

        return modelHelper.buildModalSection(<CancelButton onClick={this.handleCloseModalClick} />);
    };

    render() {
        return (
            <Modal
                onTop={false}
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.qualityControl" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{width: "60%", maxHeight: "80%", zIndex: 998}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (store.formula[ownProps.tabId] === undefined || store.qualityControl[ownProps.tabId] === undefined) {
        return {
            loggedUser: store.login.loggedUser,
            activeTabType: store.navigation.activeTabType,
            measurementSpectralData: null,
            targetSpectralData: null,
            targetFormula: null,
            differenceData: null,
            deltaE: null,
            deltaL: null,
            deltaA: null,
            deltaB: null,
            metamerism: null,
            colorDifferenceType: null
        };
    }

    return {
        loggedUser: store.login.loggedUser,
        activeTabType: store.navigation.activeTabType,
        measurementSpectralData: store.qualityControl[ownProps.tabId].measurementResult,
        targetSpectralData: store.formula[ownProps.tabId].spectralData,
        targetFormula: store.formula[ownProps.tabId].formula,
        differenceData: store.qualityControl[ownProps.tabId].result,
        deltaE: store.settings.qualityControlDeltaE,
        deltaL: store.settings.qualityControlDeltaL,
        deltaA: store.settings.qualityControlDeltaA,
        deltaB: store.settings.qualityControlDeltaB,
        metamerism: store.settings.qualityControlMetamerism,
        colorDifferenceType: store.settings.qualityControlDifference
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchInitAction: (tabId) => {
            dispatch(matchingActions.initQualityControl(tabId));
        },
        dispatchOpenMatchingTabAction: (tabId, measurementResult) => {
            dispatch(matchingActions.matchingTabFromStats(tabId, measurementResult));
        },
        dispatchSetCorrectionSceneAction: (tabId, measurementResult, targetMeasurementResult, targetFormula) => {
            dispatch(
                matchingActions.setCorrectionScene(tabId, measurementResult, targetMeasurementResult, targetFormula)
            );
        },
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.QUALITY_CONTROL_MODAL));
        }
    };
};

export default QualityControlModal = connect(mapStoreToProps, mapDispatchToProps)(QualityControlModal);
